<div class="download-container">
    <div class="app-logo">
        <img src="../../../assets/images/app_bar_logo.svg" alt="Maqare logo">
    </div>
    <div class="title">
        <span class="highlight"> مقارئ..</span>
        خيركم من تعلم القرآن وعلمه
    </div>

    <div class="app-description">
        مقارئ هي منصة تعليمية مبتكرة تُحدث نقلة نوعية في طريقة تعلم وتعليم القرآن الكريم، حيث تربط المعلمين بالطلاب من
        مختلف أنحاء العالم ضمن بيئة تعليمية مستقلة ومتطورة.
    </div>

    <div class="actions">
        <p class="text">حمل التطبيق الآن !</p>
        <div class="app-stores">
            <div class="store">
                <img src="../../../assets/images/store-apple.svg" alt="App store">
            </div>
            <div class="store">
                <img src="../../../assets/images/store-google.svg" alt="Google play">
            </div>
        </div>
        <div class="qr-code">
            <img src="../../../assets/images/qr-code.svg" alt="QR code">
        </div>
    </div>
</div>